import { Component, Input, OnChanges } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";
import { NavigationService } from "@services/navigation.service";
import { AccountService } from "../../_services/account.service";
import { FoundationAccountService } from "../../_services/account.service.ajs";
import "./reseller-name.component.scss";

@Component({
    selector: "reseller-name",
    template: require("./reseller-name.component.html")
})
export class ResellerNameComponent implements OnChanges {
    @Input() id: number;

    resellerName: string;

    constructor(
        private readonly accountService: AccountService,
        private readonly foundationAccountService: FoundationAccountService,
        private readonly translationService: TranslationService,
        private readonly navigationService: NavigationService) {
    }

    ngOnChanges() {
        this.resellerName = this.translationService.t("Common.Loading");

        this.accountService.getResellers().subscribe(resellers => {
            this.resellerName = this.foundationAccountService.getResellerName(resellers, this.id);
        });
    }

    resellerClicked() {
        //this.navigationService.go(FoundationNavigationModule.CustomerOverview, { customerId: this.id });
    }
}
